/* Input park: the Chakra textarea the drawers grow with; retires with the details-tab round (component-map.md). */
import { forwardRef, Textarea, TextareaProps } from '@chakra-ui/react';
import ResizeTextarea from 'react-textarea-autosize';

export type AutoResizeTextareaProps = TextareaProps & {
  blurOnEnter?: boolean;
};

export const AutoResizeTextarea = forwardRef<AutoResizeTextareaProps, typeof ResizeTextarea>(
  (props, ref) => {
    const { blurOnEnter, ...textareaProps } = props;

    return (
      <Textarea
        minH="unset"
        overflowX="hidden"
        // Capped by maxRows, the text runs past the box and has to scroll; uncapped, it always fits.
        overflowY={textareaProps.maxRows ? 'auto' : 'hidden'}
        w="100%"
        resize="none"
        ref={ref}
        minRows={1}
        {...textareaProps}
        onKeyDown={getOnKeyDown(props)}
        as={ResizeTextarea}
      />
    );
  },
);

function getOnKeyDown({
  blurOnEnter,
  onKeyDown,
}: AutoResizeTextareaProps): AutoResizeTextareaProps['onKeyDown'] {
  if (!blurOnEnter) {
    return onKeyDown;
  }

  return (event) => {
    if (event.key === 'Enter') {
      event.currentTarget.blur();
    }
    onKeyDown?.(event);
  };
}
